import script from "./PlayerCrud.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerCrud.vue?vue&type=script&setup=true&lang=js"

import "./PlayerCrud.vue?vue&type=style&index=0&id=8ac447ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac447ae"]])

export default __exports__